import { useEffect, useState } from 'react';
import { useAuthedApi } from '../../lib/useAuthedApi';

type Hostname = {
  id: string;
  hostname: string;
  status: 'pending' | 'active' | 'failed';
  cf_hostname_id: string | null;
  created_at: string;
};

export default function CustomHostnames() {
  const apiFn = useAuthedApi();
  const [items, setItems] = useState<Hostname[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const [hostname, setHostname] = useState('');

  const load = () =>
    apiFn<Hostname[]>('/organizations/me/custom-hostnames')
      .then(setItems)
      .catch((e) => setErr(e.message));

  useEffect(() => {
    void load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function add() {
    setErr(null);
    if (!hostname) {
      setErr('hostname_required');
      return;
    }
    try {
      await apiFn('/organizations/me/custom-hostnames', { body: { hostname } });
      setHostname('');
      await load();
    } catch (e) {
      setErr((e as Error).message);
    }
  }

  async function remove(id: string) {
    if (!confirm('Remove this hostname? Traffic to it will stop being routed.')) return;
    await apiFn(`/organizations/me/custom-hostnames/${id}`, { method: 'DELETE' });
    await load();
  }

  return (
    <div>
      <div className="card">
        <h2 style={{ marginTop: 0 }}>Add a custom hostname</h2>
        <p className="muted">
          Point a CNAME for the hostname at <code>invitey.ca</code>, then complete the Cloudflare
          for SaaS handshake (see ops docs). Until status is <code>active</code>, traffic
          here is served by your CDN normally — we won&apos;t intercept it.
        </p>
        <label>
          <span>Hostname</span>
          <input
            value={hostname}
            onChange={(e) => setHostname(e.target.value.toLowerCase())}
            placeholder="book.customer.com"
          />
        </label>
        {err && <p className="err">{err}</p>}
        <button className="primary" onClick={add}>
          Add
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>Hostname</th>
            <th>Status</th>
            <th>CF id</th>
            <th>Created</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {items.map((h) => (
            <tr key={h.id}>
              <td>{h.hostname}</td>
              <td>{h.status}</td>
              <td><code>{h.cf_hostname_id ?? '—'}</code></td>
              <td>{h.created_at}</td>
              <td>
                <button className="danger" onClick={() => remove(h.id)}>
                  Remove
                </button>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan={5} className="muted">
                No custom hostnames yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
